<template>
    <div v-if="allowRead">
        <DxPopup v-model:visible="popupVisible" :title="ttl.NewComment" width="auto" height="auto" content-template="newComment">
            <template #newComment>
                <div class="puBox">
                    <div class="cmxCell cmtTextBox">
                        <DxTextArea v-model:value="commentText" height="300" width="600" />
                    </div> 
                    <div class="cmxButtons">
                        <div class="cmxLeftButtons">
                            <DxButton :text="btn.BtnClose" @click="hideAddComment" />
                        </div>
                        <div class="cmxRightButtons">
                            <DxButton :text="btn.BtnSend" @click="saveComment()" />
                        </div>
                    </div>
                </div>
            </template>
        </DxPopup>
        <div class="cmxBox">
            <div class="echHeader frm-field-label">{{ttl.Comments}} </div> 
            <div class="echBody">
                <div class="cmtCommentList" v-if="topicCommentList && topicCommentList.length > 0">
                    <div v-for="comment in topicCommentList" :key="comment.ComId" class="cmtContent">
                        <div class="cmtAuthor">{{comment.UsrFullName}} {{ getDate(comment.ComCreatedOn)}}</div>
                        <div class="cmtComment">{{comment.ComText}}</div>
                    </div>
                </div>
                <div class="cmtButtons" v-if="allowAdd">
                    <DxButton :text="btn.BtnComment" @click="showAddComment" />
                </div>
            </div>
        </div>
    </div> 
</template>  

<script>
    import { DxButton } from 'devextreme-vue/button'
    import DxPopup from "devextreme-vue/popup"
    import DxTextArea from 'devextreme-vue/text-area'
    import moment from 'moment'

    export default {
        name: "topicComments",
        components: {
            DxButton, DxPopup, DxTextArea
        },
        data() {
            return {
                popupVisible: false,
                commentText: '',
                topicId: 0,
                args: "",
                ttl: {
                    Comments: this.$LanguageProvider.GetResource("Comments", "Caption", "Kommentare"),
                    NewComment: this.$LanguageProvider.GetResource("NewComment", "Caption", "Neuer Kommentar"),
                  
                },
                btn: {
                    BtnSend: this.$LanguageProvider.GetResource("BtnSend", "Caption", "Absenden"),
                    BtnClose: this.$LanguageProvider.GetResource("BtnClose", "Caption", "Schließen"),
                    BtnComment: this.$LanguageProvider.GetResource("BtnComment", "Caption", "Kommentieren"),
                }
            }
        },

        created() {
        },
        mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            this.topicId = urlParams.get("topicId");
            this.args = urlParams.get("args");
            this.$store.dispatch("getTopciCommentList", { topicId: this.topicId, args: this.args })
        },
        computed: {
            topicCommentList() {
                return this.$store.state.topicCommentsStore.topicCommentList
            },
            allowRead() {
                return this.$store.state.topicCommentsStore.allowRead
            },
            allowAdd() {
                return this.$store.state.topicCommentsStore.allowAdd
            },
        },
        watch: {
        },
        methods: {
            showAddComment: function () {
                this.popupVisible = true
            },
            hideAddComment: function () {
                this.popupVisible = false
            },
            saveComment: function () {
                this.$store.dispatch("addComment", { topicId: this.topicId, args: this.args, comment: this.commentText }).then(() => {
                    this.popupVisible = false
                    this.commentText = ''
                })
            },
            getDate(date) {
                return moment(date).format('DD.MM.YYYY HH:mm')
            }
        }
    };
</script>
<style scoped>
</style>